/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { isFunction } from 'lodash';
import { getEntityType } from '@constants/config';
import {
  allowedToChangeStatus,
  CONFLICT_STATUS_ROW,
  getStatus
} from '@utils/data-detail/conflicts';
import { allowResolution } from '@utils/permission-utils';
import './overlap-status-row.scss';

const OverlapStatusRow = ({
  isOpportunity,
  itemEntityType,
  mainAgency,
  mainEntityType,
  mainOverlapStatus,
  onClick,
  overlapStatus,
  showShadow
}) => {
  const statusInfo = useMemo(
    () => getStatus(mainOverlapStatus, overlapStatus, isOpportunity),
    [isOpportunity, mainOverlapStatus, overlapStatus]
  );

  const isAllowComments = useCallback(() => {
    const itemType = getEntityType(itemEntityType);
    return itemType.overlaps['allow-comments'];
  }, [itemEntityType]);

  const showLink = useCallback(() => {
    const canChangeStatus = allowedToChangeStatus(mainAgency);
    const canComment = isAllowComments();
    return canChangeStatus || canComment;
  }, [isAllowComments, mainAgency]);

  const getHint = useCallback(hint => {
    if (isFunction(hint)) {
      if (overlapStatus.length > 0) {
        return hint(overlapStatus[0]);
      }
      return null;
    }
    return hint;
  }, [overlapStatus]);

  const { status } = statusInfo;
  const { badge, hint } = CONFLICT_STATUS_ROW[status];
  const hintText = getHint(hint);
  const isAllowResolution = allowResolution(mainEntityType, itemEntityType);

  return (
    <div
      onClick={onClick}
      role="presentation"
      styleName={`status-row-container ${showShadow ? 'status-row-shadow' : ''}`}
    >
      {isAllowResolution && badge}
      <div styleName="status-hint">
        {isAllowResolution && hintText}
      </div>
      {showLink() && <div styleName="link">VIEW STATUS</div>}
    </div>
  );
};

OverlapStatusRow.propTypes = {
  isOpportunity: PropTypes.bool,
  itemEntityType: PropTypes.string,
  mainAgency: PropTypes.number,
  mainEntityType: PropTypes.string,
  mainOverlapStatus: PropTypes.array,
  onClick: PropTypes.func,
  overlapStatus: PropTypes.array,
  showShadow: PropTypes.bool
};

export default OverlapStatusRow;
